module.exports = __webpack_public_path__ + "assets/img/store-phone-5.16f5670e.png";